import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=f18f5dc4&"
import script from "./FormTextarea.vue?vue&type=script&lang=ts&"
export * from "./FormTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports